module.exports = __webpack_public_path__ + "img/hz_21.03080120.jpg";